/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { ThemeIcon, useMantineTheme, type ThemeIconProps } from '@mantine/core';

export default function TeamAvatar({ size = 24, ...props }: ThemeIconProps) {
  const theme = useMantineTheme();

  return (
    <ThemeIcon
      gradient={{ from: '#102A43', to: '#8C70FF', deg: 180 }}
      radius={theme.pf.radius.pill}
      size={size}
      variant="gradient"
      {...props}
    />
  );
}

TeamAvatar.displayName = 'TeamAvatar';
